// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2toLp","colBig":"styles_colBig__2N0rV","colSmall":"styles_colSmall__34u6U"};